import ObjectiveModal from './ObjectiveModal';

export default ObjectiveModal;
